module.exports = __webpack_public_path__ + "img/cladire2.5c163bf6.jpeg";